// @ts-nocheck
/* Store Custom File */
import { getFocalPointStyles, parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import { responsiveStyleRules } from "@insite/client-framework/Common/Utilities/responsive";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
// import Typography from "@insite/mobius/Typography"; // Store Custom Code
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Img, { ImgProps } from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getLinkTypeField, { LinkType, linkTypeOptions } from "@store/Framework/Common/Fields/Toolkit/linkType";
import { getObjectFocalPointStyles } from "@store/Framework/Common/Utilities/backgroundPosition";
import { borderedTitle } from "@store/Themes/common/mixins/title";
import breakpointUtility from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getCurrentSegmentFromUrl from "@toolkit/Framework/Common/Utilities/getCurrentSegmentFromUrl";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

const enum fields {
    background = "background",
    image = "image",
    focalPoint = "focalPoint",
    backgroundColor = "backgroundColor",
    heading = "heading",
    minimumHeight = "minimumHeight",
    subheading = "subheading",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
    buttonVariant = "variant",
    bannerWidth = "bannerWidth",
    imageOverlay = "imageOverlay",
    partialOverlay = "partialOverlay",
    partialOverlayPositioning = "partialOverlayPositioning",
    disableButton = "disableButton",
    contentPadding = "contentPadding",
    centerTextVertically = "centerTextVertically",
    horizontalAlign = "horizontalAlign", // Store Custom Code
    responsiveFontSizes = "responsiveFontSizes",
    customFontSizes = "customFontSizes",
    h1FontSize = "h1FontSize",
    h2FontSize = "h2FontSize",
    h3FontSize = "h3FontSize",
    h4FontSize = "h4FontSize",
    h5FontSize = "h5FontSize",
    h6FontSize = "h6FontSize",
    normalFontSize = "normalFontSize",
    customCSS = "customCSS",
    // Store Custom Code
    openInNewTab = "openInNewTab",
    linkType = "linkType",
    fileUrl = "fileUrl",
    mobileSpecificHeight = "mobileSpecificHeight",
    mobileMinimumHeight = "mobileMinimumHeight",
    contentDesktopWidth = "contentDesktopWidth",
    hasContentMobileWidth = "hasContentMobileWidth",
    contentMobileWidth = "contentMobileWidth",
    hasContentTabletWidth = "hasContentTabletWidth",
    contentTabletWidth = "contentTabletWidth",
    headingStyle = "headingStyle",
    headingColor = "headingColor",
    headingUnderline = "headingUnderline",
    subheadingColor = "subheadingColor",
    verticalAlign = "verticalAlign",
    secondButtonLabel = "secondButtonLabel",
    secondLinkType = "secondLinkType",
    secondButtonLink = "secondButtonLink",
    secondFileUrl = "secondFileUrl",
    secondOpenInNewTab = "secondOpenInNewTab",
    secondButtonVariant = "secondButtonVariant",
    mobileButtonsStacking = "mobileButtonsStacking",
    useSecondaryButton = "useSecondaryButton",
}

/* Store Custom Code - Start */
const linkTypeField = getLinkTypeField(fields.linkType);
/* Store Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.image]: string;
        [fields.focalPoint]:
            | "topLeft"
            | "topCenter"
            | "topRight"
            | "centerLeft"
            | "center"
            | "centerRight"
            | "bottomLeft"
            | "bottomCenter"
            | "bottomRight";
        [fields.backgroundColor]: string;
        [fields.heading]: string;
        [fields.minimumHeight]: "1/4 viewport" | "1/2 viewport" | "3/4 viewport" | "fullViewport" | "autoHeight"; // Store Custom Code
        [fields.subheading]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.buttonVariant]: "primary" | "secondary" | "tertiary";
        [fields.imageOverlay]: string;
        [fields.partialOverlay]: boolean;
        [fields.partialOverlayPositioning]: "top" | "middle" | "bottom";
        [fields.disableButton]: boolean;
        [fields.contentPadding]: number;
        [fields.centerTextVertically]: boolean;
        [fields.horizontalAlign]: "left" | "center" | "right"; // Store Custom Code
        [fields.responsiveFontSizes]: boolean;
        [fields.customFontSizes]: boolean;
        [fields.h1FontSize]: number;
        [fields.h2FontSize]: number;
        [fields.h3FontSize]: number;
        [fields.h4FontSize]: number;
        [fields.h5FontSize]: number;
        [fields.normalFontSize]: number;
        [fields.customCSS]: string;
        // Store Custom Code
        [fields.openInNewTab]: boolean;
        [fields.linkType]: LinkType;
        [fields.fileUrl]: string;
        [fields.mobileSpecificHeight]: boolean;
        [fields.mobileMinimumHeight]: number;
        [fields.contentDesktopWidth]: string;
        [fields.hasContentMobileWidth]: boolean;
        [fields.contentMobileWidth]: string;
        [fields.hasContentTabletWidth]: boolean;
        [fields.contentTabletWidth]: string;
        [fields.headingStyle]: string;
        [fields.headingColor]: string;
        [fields.headingUnderline]: boolean;
        [fields.subheadingColor]: string;
        [fields.verticalAlign]: "top" | "center" | "bottom" | "spaceBetween";
        [fields.secondButtonLabel]: string;
        [fields.secondLinkType]: string;
        [fields.secondButtonLink]: LinkFieldValue;
        [fields.secondFileUrl]: string;
        [fields.secondOpenInNewTab]: boolean;
        [fields.secondButtonVariant]: "primary" | "secondary" | "tertiary";
        [fields.mobileButtonsStacking]: "horizontal" | "vertical";
        [fields.useSecondaryButton]: boolean;
    };
    extendedStyles?: BannerStyles;
}

export interface BannerStyles {
    wrapper?: InjectableCss;
    overlayWrapper?: InjectableCss;
    /**
     * @deprecated Use the `bannerButton` property instead.
     */
    slideCenteringWrapperStyles?: InjectableCss;
    bannerLink?: LinkPresentationProps;
    bannerButton?: ButtonPresentationProps;
    // Store Custom Code
    title?: TypographyPresentationProps;
    subHeading?: TypographyPresentationProps;
    overlay?: InjectableCss;
    backgroundImgStyles?: ImgProps;
    bannerButtonContainer?: InjectableCss;
}

export const bannerStyles: BannerStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
        `,
    },
    overlayWrapper: {
        css: css`
            width: 100%;
            /* Store Removed - color */
            /* Store Removed - text-align */
            /* Store Custom Code */
            position: relative;
        `,
    },
    /* Store Custom Code - Start */
    slideCenteringWrapperStyles: {
        css: css`
            ${spacingStyles()}
            position: relative;
            height: 100%;
            z-index: 99;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        `,
    },
    backgroundImgStyles: {
        css: css`
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
        `,
    },
    overlay: {
        css: css`
            position: absolute;
            width: 100%;
            height: 100%;
        `,
    },
    title: {
        css: css`
            text-transform: uppercase;
        `,
    },
    subHeading: {
        css: css``,
    },
    bannerButton: {
        css: css`
            margin-top: ${pxToRem(16)};
        `,
    },
    bannerButtonContainer: {
        css: css`
            display: flex;
            gap: ${pxToRem(16)};
        `,
    },
    /* Store Custom Code - End */
};

export const Banner: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const link = useGetLink(fields.buttonLink); // Store Custom Code
    const secondLink = useGetLink(fields.secondButtonLink); // Store Custom Code
    const history = useHistory();
    const { isInShell } = useShellContext();
    /* Store Custom Code - Start */
    const linkType = linkTypeField.useParse(fields.linkType);
    const isFile = linkType === linkTypeOptions.file.id;
    const { url, title } = isFile ? { url: fields.fileUrl, title: getCurrentSegmentFromUrl(fields.fileUrl) } : link;
    const secondLinkType = linkTypeField.useParse(fields.secondLinkType);
    const secondIsFile = secondLinkType === linkTypeOptions.file.id;
    const { url: secondUrl, title: secondTitle } = secondIsFile
        ? { url: fields.secondFileUrl, title: getCurrentSegmentFromUrl(fields.secondFileUrl) }
        : secondLink;
    /* Store Custom Code - End */

    const onClick = (_url: string | undefined, _openInNewTab: boolean, _isFile: boolean /* Store Custom Code */) => {
        if (!_url /* Store Custom Code */) {
            return;
        }

        /* Store Custom Code - Start */
        if (_url.startsWith("mailto") || _url.startsWith("tel")) {
            window.location.href = _url;
            return;
        }
        /* Store Custom Code - End */

        if (_url.startsWith("http") /* Store Custom Code */) {
            if (isInShell && !_openInNewTab /* Store Custom Code */) {
                return;
            }

            _openInNewTab || _isFile ? window.open(_url, "_blank") : (window.location.href = _url); // Store Custom Code
        } else {
            _openInNewTab ? window.open(_url, "_blank") : history.push(_url); // Store Custom Code
        }
    };

    /* Store Custom Code - Start */
    const backgroundStyles = fields.background === "color" ? `background-color: ${fields.backgroundColor};` : "";
    /* Store Custom Code - End */

    const focalPointStyles = getObjectFocalPointStyles(fields.focalPoint); // Store Custom Code

    let minimumHeightStyles;
    switch (fields.minimumHeight) {
        case "1/4 viewport":
            minimumHeightStyles = "25vh"; // Store Custom Code
            break;
        case "1/2 viewport":
            minimumHeightStyles = "50vh;"; // Store Custom Code
            break;
        case "3/4 viewport":
            minimumHeightStyles = "75vh;"; // Store Custom Code
            break;
        case "fullViewport":
            minimumHeightStyles = "100vh;"; // Store Custom Code
            break;
        // Store Custom Code
        case "autoHeight":
            minimumHeightStyles = "100%;";
    }

    let overlayPositioningStyles;
    if (!fields.partialOverlay) {
        overlayPositioningStyles = "align-items: stretch;";
    } else if (fields.partialOverlayPositioning === "top") {
        overlayPositioningStyles = "align-items: flex-start;";
    } else if (fields.partialOverlayPositioning === "middle") {
        overlayPositioningStyles = "align-items: center;";
    } else if (fields.partialOverlayPositioning === "bottom") {
        overlayPositioningStyles = "align-items: flex-end;";
    }

    const styles = useMergeStyles("banner", bannerStyles, extendedStyles);

    let fontSizeStyles;
    if (fields.responsiveFontSizes || fields.customFontSizes) {
        fontSizeStyles = responsiveStyleRules(fields.responsiveFontSizes, fields.customFontSizes ? fields : undefined);
    }

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
            height: 100%; /* Store Custom Code */
        `,
    };

    const wrapperStyles = {
        css: css`
            ${styles.wrapper?.css || ""}
            ${backgroundStyles}
            /* Store Custom Code - Start */
            ${fields.mobileMinimumHeight
                ? breakpointValues([pxToRem(fields.mobileMinimumHeight), null, minimumHeightStyles], "height")
                : `height: ${minimumHeightStyles};`}
            /* Store Custom Code - End */
            ${overlayPositioningStyles} /* Store Removed - fontSizeStyles */
        `,
    };

    const overlayWrapperStyles = {
        css: css`
            ${styles.overlayWrapper?.css || ""};
            /* Store Moved code - background-color */
            /* Store Moded code - padding */
            /* Store Moved code - fields.centerTextVertically */
        `,
    };

    /* Store Custom Code - Start */
    const overlayStyles = {
        css: css`
            ${styles.overlay?.css}
            background-color: ${fields.imageOverlay};
        `,
    };

    const contentMobileWidth = fields.hasContentMobileWidth ? fields.contentMobileWidth : "100%";
    const contentTabletWidth = fields.hasContentTabletWidth ? fields.contentTabletWidth : "75%";

    let horizontalAlign;
    let borderedTitleAlignement;
    let horizontalAlignMargins;
    switch (fields.horizontalAlign) {
        case "left":
            horizontalAlign = "flex-start";
            horizontalAlignMargins = `
                margin-right: auto;
                margin-left: 0;
            `;
            borderedTitleAlignement = "";
            break;
        case "center":
            horizontalAlign = "center";
            horizontalAlignMargins = `
                margin-right: auto;
                margin-left: auto;
            `;
            borderedTitleAlignement = `
                left: 50%;
                transform: translateX(-50%);
            `;
            break;
        case "right":
            horizontalAlign = "flex-end";
            horizontalAlignMargins = `
                margin-right: 0;
                margin-left: auto;
            `;
            borderedTitleAlignement = `
                left: inherit;
                right: 0;
            `;
            break;
    }

    let verticalAlign;
    switch (fields.verticalAlign) {
        case "top":
            verticalAlign = "flex-start";
            break;
        case "center":
            verticalAlign = "center";
            break;
        case "bottom":
            verticalAlign = "flex-end";
            break;
        case "spaceBetween":
            verticalAlign = "space-between";
            break;
    }

    const slideCenteringWrapperStyles = {
        css: css`
            ${styles.slideCenteringWrapperStyles.css}
            ${breakpointValues([contentMobileWidth, contentTabletWidth, null, fields.contentDesktopWidth], "width")}
            ${breakpointValues(pxToRemArray([30, null, null, fields.contentPadding]), "padding")}
            ${horizontalAlignMargins}
            align-items: ${horizontalAlign};
            text-align: ${fields.horizontalAlign};
            justify-content: ${verticalAlign};
        `,
    };

    const backgroundImgStyles = {
        css: css`
            ${styles.backgroundImgStyles.css}
            ${focalPointStyles}
        `,
    };

    let buttonVariantDefaultStyles;
    switch (fields.variant) {
        case "primary":
            buttonVariantDefaultStyles = css`
                ${x => x.theme.button.primary?.css}
            `;
            break;
        case "secondary":
            buttonVariantDefaultStyles = css`
                ${x => x.theme.button.secondary?.css}
            `;
            break;
        case "tertiary":
            buttonVariantDefaultStyles = css`
                ${x => x.theme.button.tertiary?.css}
            `;
            break;
    }

    let secondButtonVariantDefaultStyles;
    switch (fields.secondButtonVariant) {
        case "primary":
            secondButtonVariantDefaultStyles = css`
                ${x => x.theme.button.primary?.css}
            `;
            break;
        case "secondary":
            secondButtonVariantDefaultStyles = css`
                ${x => x.theme.button.secondary?.css}
            `;
            break;
        case "tertiary":
            secondButtonVariantDefaultStyles = css`
                ${x => x.theme.button.tertiary?.css}
            `;
            break;
    }

    const titleStyles = {
        variant: fields.headingStyle as any,
        forwardAs: "p" as any,
        color: fields.headingColor as any,
        css: css`
            ${styles.title?.css}
            margin-bottom: ${pxToRem(8)};

            ${fields.headingUnderline ? borderedTitle(null, null, 70) : ""}
            ${fields.headingUnderline &&
            `
                &::after {
                    ${borderedTitleAlignement}
                }
            `}
        `,
    };

    const subHeadingStyles = {
        color: fields.subheadingColor as any,
        css: css`
            ${styles.subHeading?.css}
        `,
    };

    const bannerButtonStyles = {
        variant: fields.variant,
        sizeVariant: "small" as any,
        css: css`
            ${styles.bannerButton?.css}
            ${buttonVariantDefaultStyles}
        `,
    };

    const secondBannerButtonStyles = {
        variant: fields.secondButtonVariant,
        sizeVariant: "small" as any,
        css: css`
            ${styles.bannerButton?.css}
            ${secondButtonVariantDefaultStyles}

            ${breakpointUtility("sm", "down")} {
                ${fields.mobileButtonsStacking === "vertical" &&
                `
                    margin-top: 0;
                `}
            }
        `,
    };

    const bannerButtonContainerStyles = {
        css: css`
            ${styles.bannerButtonContainer?.css}

            ${breakpointUtility("sm", "down")} {
                ${fields.mobileButtonsStacking === "vertical" &&
                `
                    flex-direction: column;
                `}
            }
        `,
    };
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...customCssWrapper}>
            <StyledWrapper className="banner-wrapper" {...wrapperStyles}>
                {/* Store Custom Code - Start */}
                <StyledWrapper className="banner-overlay-wrapper" {...overlayWrapperStyles}>
                    {fields.background === "image" ? <Img src={fields.image} {...backgroundImgStyles} /> : <></>}
                    {fields.imageOverlay && fields.background === "image" && <StyledWrapper {...overlayStyles} />}
                    <StyledWrapper className="banner-center-wrapper" {...slideCenteringWrapperStyles}>
                        {fields.heading && (
                            <Typography {...titleStyles} className="banner-heading">
                                {fields.heading}
                            </Typography>
                        )}
                        <Typography {...subHeadingStyles} className="banner-subheading">
                            {parse(fields.subheading, parserOptions)}
                        </Typography>
                        {!fields.disableButton && (
                            <StyledWrapper {...bannerButtonContainerStyles}>
                                <Button
                                    {...bannerButtonStyles}
                                    onClick={() => onClick(url, fields.openInNewTab, isFile)}
                                >
                                    {fields.buttonLabel || title || url}
                                </Button>
                                {fields.useSecondaryButton && (
                                    <Button
                                        {...secondBannerButtonStyles}
                                        onClick={() => onClick(secondUrl, fields.secondOpenInNewTab, secondIsFile)}
                                    >
                                        {fields.secondButtonLabel || secondTitle || secondUrl}
                                    </Button>
                                )}
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                {/* Store Custom Code - End */}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const defaultCustomCss = `.banner-wrapper {
}

.banner-overlay-wrapper {
}

.banner-center-wrapper {
}

.banner-heading {
}

.banner-subheading {
}
`;

const basicTab = {
    displayName: "Content", // Store Custom Code
    sortOrder: 0,
};

/* Store Custom Code - Start */
const designTab = {
    displayName: "Design",
    sortOrder: 1,
};
/* Store Custom Code - End */

const settingsTab = {
    displayName: "Settings",
    sortOrder: 2, // Store Custom Code
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 3, // Store Custom Code
};

/* Store Custom Code - Start */
const headingOptions = [
    { displayName: "Heading 1", value: "h1" },
    { displayName: "Heading 2", value: "h2" },
    { displayName: "Heading 3", value: "h3" },
    { displayName: "Heading 4", value: "h4" },
    { displayName: "Heading 5", value: "h5" },
    { displayName: "Heading 6", value: "h6" },
];
/* Store Custom Code - End */

const banner: WidgetModule<Toolkit.FieldDefinition> /* Store Custom Code */ = {
    component: Banner,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                fieldType: "Contextual",
                name: fields.focalPoint,
                displayName: "Focal Point",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Top Left", value: "topLeft" },
                    { displayName: "Top Center", value: "topCenter" },
                    { displayName: "Top Right", value: "topRight" },
                    { displayName: "Center Left", value: "centerLeft" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Center Right", value: "centerRight" },
                    { displayName: "Bottom Left", value: "bottomLeft" },
                    { displayName: "Bottom Center", value: "bottomCenter" },
                    { displayName: "Bottom Right", value: "bottomRight" },
                ],
                defaultValue: "center",
                hideEmptyOption: true,
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            /* Store Custom Code - End */
            {
                fieldType: "Contextual",
                name: fields.imageOverlay,
                displayName: "Image Color Overlay",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tab: designTab, // Store Custom Code
            },
            /* Store Removed - fields.partialOverlay */
            /* Store Removed - fields.partialOverlayPositioning */
            /* Store Moved - fields.focalPoint - up */
            {
                fieldType: "Contextual",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.heading,
                editorTemplate: "TextField", // Store Custom Code
                displayName: "Heading",
                defaultValue: "",
                /* Store Removed - extendedConfig & expandedToolbarButtons */
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                fieldType: "Contextual",
                name: fields.headingStyle,
                displayName: "Heading Display Style",
                editorTemplate: "DropDownField",
                options: headingOptions,
                defaultValue: "h2",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.headingColor,
                displayName: "Heading Color",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "White", value: "primary.contrast" },
                    { displayName: "Blue", value: "primary" },
                    { displayName: "Light Blue", value: "secondary" },
                    { displayName: "Black", value: "text.main" },
                ],
                defaultValue: "primary.contrast",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.headingUnderline,
                displayName: "Red line under title?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: designTab,
            },
            /* Store Custom Code - End */
            {
                fieldType: "Contextual",
                name: fields.subheading,
                editorTemplate: "RichTextField",
                displayName: "Subheading",
                defaultValue: "",
                extendedConfig: { height: 170 },
                /* Store Removed - extendedConfig & expandedToolbarButtons */
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                fieldType: "Contextual",
                name: fields.subheadingColor,
                displayName: "Sub Heading Color",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "White", value: "primary.contrast" },
                    { displayName: "Black", value: "text.main" },
                ],
                defaultValue: "primary.contrast",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.disableButton,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: basicTab,
            },
            /* Store Custom Code - End */
            {
                fieldType: "Contextual",
                name: fields.buttonLabel,
                editorTemplate: "TextField",
                displayName: "Button Label",
                defaultValue: "",
                isVisible: widget => !widget.fields.disableButton, // Store Custom Code
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                ...linkTypeField.definition,
                isVisible: widget => !widget.fields.disableButton,
                tab: basicTab,
            },
            /* Store Custom Code - End */
            {
                fieldType: "Contextual",
                name: fields.buttonLink,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                isVisible: widget =>
                    !widget.fields.disableButton && widget.fields.linkType === linkTypeOptions.destination.id, // Store Custom Code
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                name: fields.fileUrl,
                displayName: "File",
                fieldType: "Contextual",
                editorTemplate: "FilePickerField",
                defaultValue: "",
                tab: basicTab,
                isVisible: widget => !widget.fields.disableButton && widget.fields.linkType === linkTypeOptions.file.id,
            },
            {
                fieldType: "Contextual",
                name: fields.openInNewTab,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                isVisible: widget =>
                    !widget.fields.disableButton && widget.fields.linkType === linkTypeOptions.destination.id,
                tab: basicTab,
            },
            /* Store Custom Code - End */
            {
                name: fields.buttonVariant,
                displayName: "Button Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                hideEmptyOption: true,
                defaultValue: "primary",
                fieldType: "Contextual",
                isVisible: widget => !widget.fields.disableButton, // Store Custom Code
                tab: basicTab,
            },
            /* Store Custom Code - Start */
            {
                name: "horizontalRule",
                editorTemplate: "HorizontalRule",
                defaultValue: "",
                fieldType: "General",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.secondButtonLabel,
                editorTemplate: "TextField",
                displayName: "Second Button Label",
                defaultValue: "",
                isVisible: widget => !widget.fields.disableButton && widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                ...linkTypeField.definition,
                name: fields.secondLinkType,
                displayName: "Second Link Type",
                isVisible: widget => !widget.fields.disableButton && widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.secondButtonLink,
                displayName: "Second Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                isVisible: widget =>
                    !widget.fields.disableButton &&
                    widget.fields.secondLinkType === linkTypeOptions.destination.id &&
                    widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                name: fields.secondFileUrl,
                displayName: "Second File",
                fieldType: "Contextual",
                editorTemplate: "FilePickerField",
                defaultValue: "",
                tab: basicTab,
                isVisible: widget =>
                    !widget.fields.disableButton &&
                    widget.fields.secondLinkType === linkTypeOptions.file.id &&
                    widget.fields.useSecondaryButton,
            },
            {
                fieldType: "Contextual",
                name: fields.secondOpenInNewTab,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                isVisible: widget =>
                    !widget.fields.disableButton &&
                    widget.fields.secondLinkType === linkTypeOptions.destination.id &&
                    widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                name: fields.secondButtonVariant,
                displayName: "Second Button Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                hideEmptyOption: true,
                defaultValue: "primary",
                fieldType: "Contextual",
                isVisible: widget => !widget.fields.disableButton && widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                name: fields.mobileButtonsStacking,
                displayName: "Mobile Buttons Stacking",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Horizontal", value: "horizontal" },
                    { displayName: "Vertical", value: "vertical" },
                ],
                hideEmptyOption: true,
                defaultValue: "horizontal",
                fieldType: "Contextual",
                isVisible: widget => !widget.fields.disableButton && widget.fields.useSecondaryButton,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.useSecondaryButton,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: basicTab,
            },
            /* Store Custom Code - End */
            {
                fieldType: "Contextual",
                name: fields.minimumHeight,
                displayName: "Minimum Banner Height",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "1/4 Viewport", value: "1/4 viewport" },
                    { displayName: "1/2 Viewport", value: "1/2 viewport" },
                    { displayName: "3/4 Viewport", value: "3/4 viewport" },
                    { displayName: "Full Viewport", value: "fullViewport" },
                    // Store Custom Code
                    { displayName: "Auto Height (Fit to container)", value: "autoHeight" },
                ],
                defaultValue: "autoHeight", // Store Custom Code
                hideEmptyOption: true,
                tab: designTab, // Store Custom Code
            },
            /* Store Custom Code - Start */
            {
                fieldType: "Contextual",
                name: fields.mobileSpecificHeight,
                displayName: "Mobile Specific Height",
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: false,
                tab: designTab,
            },
            {
                fieldType: "Contextual",
                name: fields.mobileMinimumHeight,
                displayName: "Mobile Minimum Banner Height",
                editorTemplate: "IntegerField",
                defaultValue: null,
                tab: designTab,
                isVisible: item => item?.fields[fields.mobileSpecificHeight],
            },
            /* Store Custom Code - End */
            /* Store Moved - disableButton - up */
            {
                name: fields.responsiveFontSizes,
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                tab: settingsTab,
                defaultValue: true,
            },
            {
                fieldType: "Contextual",
                name: fields.contentPadding,
                editorTemplate: "IntegerField",
                defaultValue: 50,
                tab: designTab, // Store Custom Code
            },
            // Store Custom Code - Removed centerTextVertically
            /* Store Custom Code - Start */
            {
                name: fields.verticalAlign,
                displayName: "Vertical Alignement",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Top", value: "top" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Bottom", value: "bottom" },
                    { displayName: "Space-Between", value: "spaceBetween" },
                ],
                hideEmptyOption: true,
                defaultValue: "top",
                fieldType: "Contextual",
                tab: designTab,
            },
            {
                name: fields.horizontalAlign,
                displayName: "Horizontal Alignement",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "left" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "right" },
                ],
                hideEmptyOption: true,
                defaultValue: "left",
                fieldType: "Contextual",
                tab: designTab,
            },
            /* Store Custom Code - End */
            /* Store Removed - fields.customFontSizes */
            {
                name: fields.normalFontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h1FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: 40,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h2FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: 32,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h3FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h4FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h5FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h6FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "Contextual",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.contentDesktopWidth,
                displayName: "Desktop Content Width",
                editorTemplate: "DropDownField",
                defaultValue: "50%",
                options: [{ value: "50%" }, { value: "66%" }, { value: "75%" }, { value: "80%" }, { value: "100%" }],
                tab: designTab,
            },
            {
                fieldType: "Contextual",
                name: fields.hasContentMobileWidth,
                displayName: "Specific Mobile Content Width?",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                variant: "toggle",
                tab: designTab,
            },
            {
                fieldType: "Contextual",
                name: fields.contentMobileWidth,
                displayName: "Mobile Content Width",
                editorTemplate: "DropDownField",
                defaultValue: "50%",
                options: [{ value: "50%" }, { value: "66%" }, { value: "75%" }, { value: "80%" }, { value: "100%" }],
                tab: designTab,
                isVisible: item => item.fields.hasContentMobileWidth,
            },
            {
                fieldType: "Contextual",
                name: fields.hasContentTabletWidth,
                displayName: "Specific Tablet Content Width?",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                variant: "toggle",
                tab: designTab,
            },
            {
                fieldType: "Contextual",
                name: fields.contentTabletWidth,
                displayName: "Tablet Content Width",
                editorTemplate: "DropDownField",
                defaultValue: "50%",
                options: [{ value: "50%" }, { value: "66%" }, { value: "75%" }, { value: "80%" }, { value: "100%" }],
                tab: designTab,
                isVisible: item => item.fields.hasContentTabletWidth,
            },
        ],
    },
};

export default banner;
